import { render, staticRenderFns } from "./UrunSatisFiyatItem.vue?vue&type=template&id=6962a089&scoped=true"
import script from "./UrunSatisFiyatItem.vue?vue&type=script&lang=js"
export * from "./UrunSatisFiyatItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6962a089",
  null
  
)

export default component.exports